import { Routes, Route } from 'react-router';
import ListaActivosView from './views/ListaActivosView';
import ListLocationsView from './locations/views/ListLocationsView';
import CreateUpdatelocationView from './locations/views/CreateUpdatelocationView';
import ListEquipmentsView from './equipment/views/ListEquipmentsView';
import CreateUpdateEquipmentView from './equipment/views/CreateUpdateEquipmentView';
export default function CatalogRouter() {
    return (
        <Routes>
            <Route path="/" element={<ListaActivosView />} />
            <Route path="/ubicaciones" element={<ListLocationsView />} />
            <Route path="/ubicaciones/crear" element={<CreateUpdatelocationView />} />
            <Route path="/ubicaciones/update/:hash" element={<CreateUpdatelocationView />} />

            {/* EQUIPOS */}
            <Route path="/equipos" element={<ListEquipmentsView />} />
            <Route path="/equipos/crear" element={<CreateUpdateEquipmentView />} />
            <Route path="/equipos/update/:hash" element={<CreateUpdateEquipmentView />} />

            
        </Routes>
    )
}